import {
  StoreSelector,
  useAppStoreSelector,
} from '../../../shared/store/model/context';
import { LoadingState } from '../../../shared/store/model/types';
import { UserSlice } from './types';

type UserStoreState = UserSlice & {
  loading: LoadingState;
};

type UserStoreSelector<T> = StoreSelector<UserStoreState, T>;

export const userSelectors = {
  user: (state) => state.user,
  hydrated: (state) => state.hydrated,
  bootstrap: (state) => state.bootstrap,
  logout: (state) => state.logout,
  bootstrapLoading: (state) => state.loading.bootstrap,
  token: (state) => state.token,
  refreshUser: (state) => state.refreshUser,
} satisfies Record<string, UserStoreSelector<unknown>>;

export function useUserStore<T>(selector: UserStoreSelector<T>) {
  return useAppStoreSelector(selector);
}
